import { render, staticRenderFns } from "./CoachReorder.vue?vue&type=template&id=6d236992&scoped=true&"
import script from "./CoachReorder.vue?vue&type=script&lang=js&"
export * from "./CoachReorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d236992",
  null
  
)

export default component.exports